var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Broken_Chart",
    "data-name": "Iconly/Broken/Chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.24,
    viewBox: "0 0 28 28.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "coins-icon",
    "data-name": "Chart",
    d: "M8.755,28.24C3.349,28.24,0,24.862,0,19.423V8.83C0,3.378,3.349,0,8.755,0H19.245C24.627,0,28,3.378,28,8.83v3.279a1.075,1.075,0,0,1-1.071,1.08h-.013a1.054,1.054,0,0,1-.757-.322,1.076,1.076,0,0,1-.3-.771V8.83c0-4.3-2.352-6.669-6.613-6.669H8.755c-4.273,0-6.613,2.373-6.613,6.669V19.423c0,4.3,2.352,6.657,6.613,6.657H19.245c4.273,0,6.613-2.373,6.613-6.657a1.071,1.071,0,1,1,2.142,0c0,5.439-3.349,8.817-8.742,8.817Zm-.776-6.383A1.076,1.076,0,0,1,6.945,20.74V11.7A1.07,1.07,0,0,1,8.8,11.01a1.084,1.084,0,0,1,.287.775v9.028a1.076,1.076,0,0,1-1.072,1.044Zm5-1.1V7.513a1.071,1.071,0,1,1,2.142,0V20.752a1.071,1.071,0,1,1-2.142,0Zm5.935-.013V16.517a1.072,1.072,0,1,1,2.143,0V20.74a1.072,1.072,0,1,1-2.143,0ZM12.978,7.451v.062Z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.1725c78fd481ab52b604b24675b9210f.svg";
export { ForwardRef as ReactComponent };